import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { ChevronLeft, ChevronRight, ClipboardList } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { imgUrl } from "../../lib/api";
import { BookToggle } from "./PhotoCard";

export const Lightbox = ({ items, index, setIndex, catName: baseCat, slug: baseSlug, page: basePage }) => {
  const navigate = useNavigate();
  const { addRecent } = useCart();
  const photo = index >= 0 ? items[index] : null;
  const slug = photo?.slug || baseSlug;
  const catName = photo?.catName || baseCat;
  const page = photo?.slug ? null : basePage;
  const step = (d) => setIndex((i) => (i + d + items.length) % items.length);

  useEffect(() => {
    if (!photo) return;
    addRecent({ id: photo.id, title: photo.title, url: photo.url, slug, catName, page });
  }, [photo, slug, catName, page, addRecent]);

  useEffect(() => {
    if (!photo) return undefined;
    const key = (e) => {
      if (e.key === "ArrowRight") step(1);
      if (e.key === "ArrowLeft") step(-1);
    };
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  });

  return (
    <Dialog open={!!photo} onOpenChange={(o) => !o && setIndex(-1)}>
      <DialogContent data-lenis-prevent className="max-w-5xl gap-0 overflow-hidden rounded-[24px] border-[#D4AF37]/30 bg-[#190317] p-0 text-[#FFF8EF]" data-testid="photo-lightbox">
        {photo && (
          <>
            <div className="relative flex items-center justify-center bg-black/40">
              <img src={imgUrl(photo.url)} alt={photo.title} className="max-h-[68vh] w-full object-contain" data-testid="lightbox-image" />
              <button onClick={() => step(-1)} className="absolute left-3 flex h-11 w-11 items-center justify-center rounded-full bg-[#240620]/80 text-[#F3E5AB] backdrop-blur" data-testid="lightbox-prev" aria-label="Previous photo"><ChevronLeft size={20} /></button>
              <button onClick={() => step(1)} className="absolute right-3 flex h-11 w-11 items-center justify-center rounded-full bg-[#240620]/80 text-[#F3E5AB] backdrop-blur" data-testid="lightbox-next" aria-label="Next photo"><ChevronRight size={20} /></button>
            </div>
            <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
              <div>
                <DialogTitle className="font-display text-2xl font-medium">{photo.title}</DialogTitle>
                <DialogDescription className="mt-1 text-sm text-[#E8D8C8]">{catName} · {index + 1} of {items.length} on this page</DialogDescription>
              </div>
              <div className="flex flex-wrap gap-2">
                <BookToggle photo={photo} catName={catName} slug={slug} testId="lightbox-book" className="px-5 py-3 text-sm" />
                <button onClick={() => navigate({ pathname: "/", hash: "enquire" }, { state: { category: slug, photo: photo.title } })} className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/50 px-5 py-3 text-sm font-semibold text-[#F3E5AB]" data-testid="lightbox-enquiry-form">
                  <ClipboardList size={16} /> Enquiry form
                </button>
              </div>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
